import * as actions from './actionsTypes';

const initialData = {
  loading: false,
  saveLoader: false,
  healthLength: 0,
  health: [],
}

export default function healthReducer(state = initialData, action){
  switch (action.type) {
    case actions.LOADING_HEALTH:
      return {...state, loading: action.payload}
    case actions.SAVE_LOADER_HEALTH:
      return {...state, saveLoader: action.payload}
    case actions.GET_HEALTH:
      return {...state, health: action.payload.health, healthLength: action.payload.healthLength}
    default:
      return {...state};
  }
}